export default __webpack_public_path__ + "static/media/delete.65eaf539.svg";